module.exports = __webpack_public_path__ + "static/media/image01.ec6166e7.png";